'use client';
import { ReactComponent } from './search-xs.svg';
export const SearchIconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=search-xs.js.map